// extracted by mini-css-extract-plugin
module.exports = {"info":"styles-module--info--1f6MT"};